<template>
  <div class="footer-container container">
    <div class="footer-ribbon">
      <div><span id="title-contact">Liên hệ</span></div>
    </div>
    <div class="contact">
      <div class="footer-item" v-if="info.fullName">
        <h5>
          Hệ thống hỗ trợ nâng cao chất lượng tài liệu
        </h5>
      </div>
      <div class="footer-item">
        <div>
          <FAIcon icon="fas fa-map-marked-alt" />&ensp;
          <b>Địa chỉ: </b>Nhà C1T, Đại học Quốc gia Hà Nội, 144 Xuân Thủy, Cầu Giấy, Hà Nội
        </div>
      </div>
      <div class="footer-item">
        <div>
          <FAIcon icon="fas fa-envelope" />&ensp;
          <b>E-mail: </b><a href="mailto:lic@vnu.edu.vn" target="_blank">lic@vnu.edu.vn</a>
        </div>
      </div>
<!--      <div class="footer-item">-->
<!--        <div cols="10">-->
<!--          <FAIcon icon="fab fa-facebook-f" />&ensp;-->
<!--          <b>Facebook: </b><a href="https://www.facebook.com/doitvn" target="_blank">doitvn</a>-->
<!--        </div>-->
<!--      </div>-->
      <div class="footer-item">
        <div cols="10">
          <FAIcon icon="fas fa-comment-dots" />&ensp;
          <span>Nếu bạn có bất cứ ý kiến đóng góp hoặc cần hỗ trợ về hệ thống, xin vui lòng phản hồi tại <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSeGMmLYz7tcYX35F5QDfkca8G9ZvExGi1Pg_-VVgr8qVuEYag/viewform?usp=sf_link"
            target="_blank">đây</a></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTenantConfig } from '../services/doit_config_service'
import FAIcon from '@/components/common/FAIcon.vue'

export default {
  name: 'Footer',
  components: { FAIcon },
  data: () => {
    return {
      info: {}
    }
  },
  async created() {
    let { address, email, phone, fullName } = await getTenantConfig('tenant_config')
    this.info = { address, email, phone, fullName }
  }
}
</script>

<style lang="scss" scoped>
.contact {
  padding-top: 25px;
}

.footer-container {
  margin-top: 20px;
  padding-bottom: 20px;

  .footer-ribbon {
    background: #0088cc;
    position: absolute;
    margin: -35px 0 0 14px;
    padding: 10px 20px 6px 20px;
  }

  .footer-ribbon:before {
    border-right: 10px solid #005580;
    border-top: 16px solid transparent;
    content: '';
    display: block;
    height: 0;
    left: -10px;
    position: absolute;
    top: 0;
    width: 7px;
  }
}

#title-contact {
  color: #fff;
}

.footer-item {
  padding: 5px;
}

a {
  text-decoration: none;
}
</style>
